import { inject, type VNodeChild } from 'vue';
import type { CreateToasterReturn } from '@ark-ui/vue/toast';
import type { Options } from '@zag-js/toast';
import { toastInjectionKey } from '../utils/keys';

export function useToast() {
  let toaster: CreateToasterReturn | null | undefined = null;

  if (!import.meta.env.SSR) {
    toaster = inject(toastInjectionKey);
  }
  else {
    toaster = null;
  }

  return {
    toaster,

    create: (options: Options<VNodeChild>) => {
      if (toaster) {
        return toaster.create(options);
      }
    },

    success: (options: Options<VNodeChild> | string | undefined) => {
      if (toaster && options) {
        if (typeof options === 'string') {
          return toaster.success({ description: options });
        }

        return toaster.success(options);
      }
    },

    error: (options: Options<VNodeChild> | string | undefined) => {
      if (toaster && options) {
        if (typeof options === 'string') {
          return toaster.error({ description: options });
        }

        return toaster.error(options);
      }
    },
  };
}
